/* ==========================================================================
   HYPER SKIN JS — MegaMart Online
   Transforma a barra de anúncio do Warehouse em um marquee infinito,
   igual ao efeito usado pelo tema Hyper (murs-du-temps.com).
   Seguro: se algo não existir na página, simplesmente não faz nada.
   ========================================================================== */

(function () {
  'use strict';

  function initMarquee() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar || bar.dataset.hyperMarquee === 'done') return;

    var content = bar.querySelector('.announcement-bar__content');
    if (!content) return;

    var text = (content.textContent || '').trim();
    if (!text) return;

    // Respeita usuários que preferem menos movimento
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      bar.dataset.hyperMarquee = 'done';
      return;
    }

    var inner = bar.querySelector('.announcement-bar__inner') || bar;

    // Monta um grupo de itens (texto ✦ texto ✦ ...) e duplica o grupo:
    // a animação anda -50%, então 2 grupos idênticos = loop perfeito.
    function buildGroup() {
      var frag = document.createDocumentFragment();
      var repeats = 6;
      for (var i = 0; i < repeats; i++) {
        var item = content.cloneNode(true);
        item.classList.add('hyper-marquee__item');
        item.removeAttribute('id');
        frag.appendChild(item);

        var sep = document.createElement('span');
        sep.className = 'hyper-marquee__sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = '\u2726'; /* ✦ */
        frag.appendChild(sep);
      }
      return frag;
    }

    var track = document.createElement('div');
    track.className = 'hyper-marquee__track';
    track.appendChild(buildGroup());
    track.appendChild(buildGroup());

    var wrap = document.createElement('div');
    wrap.className = 'hyper-marquee';
    wrap.setAttribute('role', 'marquee');
    wrap.setAttribute('aria-label', text);
    wrap.appendChild(track);

    // Substitui apenas o conteúdo original, preservando botões vizinhos
    content.parentNode.replaceChild(wrap, content);
    inner.style.width = '100%';
    bar.dataset.hyperMarquee = 'done';

    // Ajusta a duração conforme o tamanho do texto (velocidade constante)
    try {
      var pxPerSecond = 60;
      var half = track.scrollWidth / 2;
      if (half > 0) {
        track.style.animationDuration = Math.max(12, half / pxPerSecond) + 's';
      }
    } catch (e) {
      /* mantém a duração padrão definida no CSS */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }

  // O Shopify recarrega seções no editor de temas — re-inicializa se preciso
  document.addEventListener('shopify:section:load', function () {
    initMarquee();
  });

  /* ------------------------------------------------------------------------
     Correção: botão "Finalizar Compra" duplicado (checkout Yampi).
     O clone da Yampi tem classes ymp_check_mainBtn/ymp_elem_mainBtn mas NÃO
     tem name="checkout". Além disso, o Warehouse re-renderiza o carrinho via
     AJAX ao mudar quantidades, e o botão original volta a aparecer. Por isso:
     - detectamos o clone pela classe (não pelo name);
     - escondemos o original (name="checkout" sem classe ymp_elem_);
     - observamos o DOM continuamente (com debounce) para pegar re-renders.
     Nunca escondemos o botão da Yampi, que é o funcional.
     ------------------------------------------------------------------------ */

  function isYampiClone(el) {
    return el.className && String(el.className).indexOf('ymp_elem_') !== -1;
  }

  function dedupeCheckoutButtons() {
    // Barato: se não há clone da Yampi na página, não faz nada
    var clones = document.querySelectorAll('[class*="ymp_elem_"]');
    if (!clones.length) return;

    for (var i = 0; i < clones.length; i++) {
      var clone = clones[i];
      if (clone.tagName !== 'BUTTON' && clone.tagName !== 'INPUT' && clone.tagName !== 'A') continue;

      var container = clone.closest('form') || clone.closest('.cart-recap') ||
                      clone.closest('.mini-cart') || clone.parentNode;
      if (!container) continue;

      var originals = container.querySelectorAll(
        '[name="checkout"], .cart-recap__checkout, .mini-cart__button-checkout'
      );
      for (var j = 0; j < originals.length; j++) {
        if (!isYampiClone(originals[j])) {
          originals[j].classList.add('hyper-hidden-duplicate');
        }
      }

      // Rede de segurança: se houver MAIS DE UM clone da Yampi no mesmo
      // container (ex.: script incluído em dobro), mantém apenas o primeiro
      var containerClones = container.querySelectorAll('.ymp_elem_mainBtn');
      for (var k = 1; k < containerClones.length; k++) {
        containerClones[k].classList.add('hyper-hidden-duplicate');
      }
    }
  }

  var dedupeScheduled = false;
  function scheduleDedupe() {
    if (dedupeScheduled) return;
    dedupeScheduled = true;
    setTimeout(function () {
      dedupeScheduled = false;
      dedupeCheckoutButtons();
    }, 100);
  }

  function initCheckoutDedupe() {
    dedupeCheckoutButtons();

    // A Yampi injeta o clone de forma assíncrona E o carrinho re-renderiza
    // via AJAX ao mudar quantidades — observa continuamente (debounced)
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(scheduleDedupe)
        .observe(document.body, { childList: true, subtree: true });
    }

    // Redundância leve para eventos do tema
    document.addEventListener('cart:rerendered', scheduleDedupe);
    document.addEventListener('product:added', scheduleDedupe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutDedupe);
  } else {
    initCheckoutDedupe();
  }
})();
